import { Temporal } from '@imago/api-client'
import { serializeUserProfileContent, UserProfileContent } from "@imago/model"
import { QueryClient, useMutation, useQueryClient } from "@tanstack/react-query"
import { FatUserQuery } from "./user.ts"
import { api } from "./_imago_api.ts"
import { useNow } from './Now.ts'

const ProfileQuery = {
	use() {
		return {data: FatUserQuery.use().data?.userProfile}
	},
	async setData(qc: QueryClient, k: [], userProfile: UserProfileContent) {
		await FatUserQuery.patchData(qc, [], old => ({
			...old!,
			userProfile,
		}))
	},
	async invalidate(qc: QueryClient, k: []) {
		await FatUserQuery.invalidate(qc, [])
	},
}

export function useProfile() {
	return ProfileQuery.use().data
}

export function useOver18() {
	const now = useNow('hour')
	const profile = useProfile()
	if (profile === undefined || profile === null) return
	return Temporal.PlainDate.compare(now.toPlainDate(), profile.dateOfBirth.add({years: 18})) >= 0
}

export function useSetProfile() {
	const qc = useQueryClient()

	const mutation = useMutation({
		mutationFn: async (profile: UserProfileContent) => {
			try {
				await api.put('user-profile/', {
					json: serializeUserProfileContent(profile),
				})
				ProfileQuery.setData(qc, [], profile)
			} catch (e) {
				ProfileQuery.invalidate(qc, [])
				throw e
			}
		}
	})
	return mutation
}
